module.exports = __webpack_public_path__ + "static/media/03.9f204671.png";